import { numberRequiredSchema, select2RequiredSchema, stringRequiredSchema, stringSchema } from "utils/validation/validationHelpers";
import { object } from 'yup';

const schema = object().shape({
 
});

export default schema;